import { MaterialService } from './../../service/material.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { KiwixiService } from '../../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import 'rxjs';

@Injectable()
export class DownloadLingueoService extends KiwixiService {
  apiDocumentationDownloadURL = environment.server + 'documents/documentation/';
  apiDocumentAdministratifDownloadURL = environment.server + 'documents/administratif/';


  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,
    ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  downloadDoc(_url, _filename): Observable<any> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get(_url, { headers: header, responseType: 'arraybuffer' })
  }

  loadFile(url, params) {
    const header = this.createHttpClientAuthorizationHeader();
    this._http.get(url, { headers: header, params: params, responseType: 'arraybuffer' })
      .subscribe((file: ArrayBuffer) => {
        this.downloadFile(params.get('filename'), file);
      });
  }

  downloadTemplate(params) {
    this.loadFile(this.apiDocumentationDownloadURL, params);
  }

  downloadDocumentAdministratif(params) {
    this.loadFile(this.apiDocumentAdministratifDownloadURL, params);
  }
}
